import syncFields from '../_syncfields.js';
import reportModified from '../_reportmodified.js';
import updateTracked from './_updatetracked.js';
import itemsNotIn from '../_diffitems.js';
import withLengthOptions from '../_withlengthoptions.js';
import arrayFrom from '../../_helpers/arrayfrom.js';
import assign from '../../_helpers/assign.js';
// recreates an array
export default function recreate(newItemsOrNull, eventOptions) {
  var _this = this;
  if (newItemsOrNull === void 0) {
    newItemsOrNull = [];
  }
  if (eventOptions === void 0) {
    eventOptions = {};
  }
  // null empties the array, as undefined does
  var givenNewItems = newItemsOrNull != null ? newItemsOrNull : [];
  var def = syncFields(this);
  var itemMediator = def.itemMediator;
  var newLength = givenNewItems.length;
  var oldLength = this.length;
  var lengthDiff = oldLength - newLength;
  var was = this.toJSON(false);
  var trackBy = this.trackBy;
  var _eventOptions = eventOptions,
    skipItemMediator = _eventOptions.skipItemMediator;
  var newItems;
  if (trackBy) {
    // if trackBy property is given then update givenNewItems array
    newItems = updateTracked({
      arr: this,
      givenNewItems: givenNewItems,
      trackBy: trackBy
    });
  } else {
    // if trackBy is not given then use given new items as is (an array-like is copied into an array)
    newItems = Array.isArray(givenNewItems) ? givenNewItems : arrayFrom(givenNewItems);
  }
  // call item mediator for every new item (but don't modify passed newItems)
  if (itemMediator && !skipItemMediator) {
    var toMediate = newItems;
    newItems = Array(newLength);
    for (var i = 0; i < newLength; i++) {
      newItems[i] = itemMediator(toMediate[i], i);
    }
  }
  // update array indexes with new values
  for (var _i = 0; _i < newLength; _i++) {
    this[_i] = newItems[_i];
  }
  // remove old items that is out of new length
  for (var _i2 = 0; _i2 < lengthDiff; _i2++) {
    delete this[_i2 + newLength];
  }
  // update length
  withLengthOptions(this, eventOptions, function () {
    _this.length = newLength;
  });
  // counted per value, so a dropped duplicate counts as removed
  var removed = itemsNotIn(was, newItems);
  var added = itemsNotIn(newItems, was);
  var reordered = false;
  if (!added.length && !removed.length) {
    for (var _i3 = 0; _i3 < newLength; _i3++) {
      if (newItems[_i3] !== was[_i3]) {
        reordered = true;
        break;
      }
    }
  }
  reportModified(this, assign({
    added: added,
    removed: removed,
    method: 'recreate',
    self: this
  }, eventOptions), reordered);
  return this;
}